export default __webpack_public_path__ + "static/media/Comments.81e26607.svg";